// states/serviceAccountSlice.ts

import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAccountCollaborator, IServiceAccount } from "../models/interfaces";
import { InitialServiceAccountDetails } from "../transformer";

const initialState = {
	loading: false,
	error: false,

	serviceAccountsData: {
		tableData: [],
		copiedData: [],
	},

	selectedRowKeys: [],
	searchText: "",
	toggle: false,

	errorData: null,
	errorHeaderTitle: "",
	isErrorModalVisible: false,

	disabledFields: false,
	serviceAccountDetails: InitialServiceAccountDetails,
	openServiceAccountModal: false,

	// NEW: Collaborators state
	collaborators: [] as IAccountCollaborator[],
	collaboratorsLoading: false,
};

const serviceAccountSlice = createSlice({
	name: "serviceAccountManagement",
	initialState,
	reducers: {
		/* ---------- TABLE DATA ---------- */

		setServiceAccountsData: (state, action: PayloadAction<any>) => {
			state.serviceAccountsData = action.payload;
		},

		setSelectedRowKeys: (state, action: PayloadAction<any[]>) => {
			state.selectedRowKeys = action.payload;
		},

		setSearchText: (state, action: PayloadAction<string>) => {
			state.searchText = action.payload;
		},

		setToggle: (state, action: PayloadAction<boolean>) => {
			state.toggle = action.payload;
		},

		/* ---------- ERROR HANDLING ---------- */

		setIsErrorModalVisible: (state, action: PayloadAction<boolean>) => {
			state.isErrorModalVisible = action.payload;
		},

		setErrorData: (state, action: PayloadAction<any>) => {
			state.errorData = action.payload;
		},

		setErrorHeaderTitle: (state, action: PayloadAction<string>) => {
			state.errorHeaderTitle = action.payload;
		},

		/* ---------- FORM / MODAL ---------- */

		setDisableFields: (state, action: PayloadAction<boolean>) => {
			state.disabledFields = action.payload;
		},

		setServiceAccountDetails: (state, action: PayloadAction<IServiceAccount>) => {
			state.serviceAccountDetails = action.payload;
		},

		setOpenServiceAccountModal: (state, action: PayloadAction<boolean>) => {
			state.openServiceAccountModal = action.payload;
		},

		/* ---------- COLLABORATORS ---------- */

		setCollaborators: (state, action: PayloadAction<IAccountCollaborator[]>) => {
			state.collaborators = action.payload;
		},

		setCollaboratorsLoading: (state, action: PayloadAction<boolean>) => {
			state.collaboratorsLoading = action.payload;
		},

		/* ---------- GLOBAL ---------- */

		setLoading: (state, action: PayloadAction<boolean>) => {
			state.loading = action.payload;
		},

		setError: (state, action: PayloadAction<boolean>) => {
			state.error = action.payload;
		},
	},
});

export const {
	setServiceAccountsData,
	setSelectedRowKeys,
	setSearchText,
	setToggle,
	setIsErrorModalVisible,
	setErrorData,
	setErrorHeaderTitle,
	setDisableFields,
	setServiceAccountDetails,
	setLoading,
	setError,
	setOpenServiceAccountModal,
	setCollaborators,
	setCollaboratorsLoading,
} = serviceAccountSlice.actions;

export default serviceAccountSlice.reducer;
